import React from 'react';
import Toast from './Toast';
import { ToastData } from '../../hooks/useToast';
import styles from './ToastContainer.module.css';

interface ToastContainerProps {
  toasts: ToastData[];
  onClose: (id: number) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onClose }) => {
  return (
    <div className={styles.toastContainer}>
      {toasts.map((toast, index) => (
        <div key={toast.id} style={{ marginBottom: index < toasts.length - 1 ? '10px' : '0' }}>
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => onClose(toast.id)}
            duration={toast.duration}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
